import type { Service } from "@eai-toolkit/client";

import {
  type BaseQueryState,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateFromStringBase,
} from "../utils/queryStateUtils";

export type ServicesQueryState = BaseQueryState<Service>;

const DEFAULT_SORT: ServicesQueryState["query"]["sort"] = {
  fieldName: "fullName",
  direction: "asc",
};

export function hydrateServicesQueryStateFromString(
  searchString: string,
): ServicesQueryState {
  return hydrateQueryStateFromStringBase<Service>(searchString, {
    defaultSort: DEFAULT_SORT,
    defaultLimit: 10,
  });
}

export function dehydrateServicesQueryStateToString(
  queryState: ServicesQueryState,
): string {
  return dehydrateQueryStateToStringBase<Service>(queryState);
}
